export default __webpack_public_path__ + "static/video-thumbnail-img-251ccaec52682ff9d78d9a42394ebeb2.jpg";